import { DocumentCoverage } from 'dashboard/models/document-coverage';
import Action from 'lib/interfaces/Action';

export type DocumentCoverageActions = Action<
  DocumentCoverageActionType.SetDocumentCoverage,
  SetDocumentCoveragePayload
>;

export enum DocumentCoverageActionType {
  SetDocumentCoverage = 'SET_DOCUMENT_AI_COVERAGE',
}

interface SetDocumentCoveragePayload {
  documentCoverage: DocumentCoverage;
}

export function setDocumentCoverage(
  documentCoverage: DocumentCoverage,
): Action<DocumentCoverageActionType.SetDocumentCoverage, SetDocumentCoveragePayload> {
  return {
    payload: {
      documentCoverage,
    },
    type: DocumentCoverageActionType.SetDocumentCoverage,
  };
}
